import { isSameId } from "../../helpers";
export default function (store, { id }) {
    if (id) {
        const state = store.getState();
        const columnIndex = state.columns.findIndex(col => isSameId(col.id, id));
        const originalColumn = state.columns[columnIndex];
        const before = state.columns[columnIndex + 1]?.id;
        const columns = state.columns.filter(col => !isSameId(col.id, id));
        const { cardsMap, areasMeta } = store.getInnerState({
            ...state,
            columns,
        });
        store.setState({ columns, cardsMap, areasMeta });
        return () => {
            store.in.exec("add-column", {
                column: originalColumn,
                before,
                $meta: {
                    skipHistory: true,
                    restore: id,
                },
            });
        };
    }
}
//# sourceMappingURL=delete.js.map